/**
 * Colour theme: "light", "dark" or "system" (follow the OS). The preference lives in localStorage
 * under THEME_KEY; the resolved theme is written to <html data-theme> before first paint by
 * THEME_SCRIPT (inlined in SiteRoot's <head>), so a dark preference never flashes light.
 *
 * Every page is on design system v2, so the toggle is public (THEMES_PUBLIC). `?theme=dark|light`
 * still forces a theme for one page view (reviews, screenshots).
 */
export const THEME_KEY = "codifly-theme";
export const THEMES_PUBLIC = true;
export const themePreferences = ["system", "light", "dark"] as const;
export type ThemePreference = (typeof themePreferences)[number];

export const THEME_SCRIPT = `(function(){try{var d=document.documentElement,q=new URLSearchParams(location.search).get("theme"),p=${THEMES_PUBLIC ? `q||localStorage.getItem("${THEME_KEY}")||"system"` : `q||"light"`};if(p!=="light"&&p!=="dark")p="system";var m=window.matchMedia("(prefers-color-scheme: dark)");var apply=function(){d.dataset.theme=p==="dark"||(p==="system"&&m.matches)?"dark":"light";d.dataset.themePreference=p;};apply();if(p==="system"&&m.addEventListener)m.addEventListener("change",apply);}catch(e){}})();`;
